import { LibraryPanel } from "@/components/LibraryPanel";

export default function SharedLibrary() {
  return (
    <div>
      <div className="mb-8">
        <div className="overline mb-2">From Tactis</div>
        <h1 className="font-dash text-3xl">Shared Documents</h1>
        <p className="text-zinc-500 mt-2 text-sm">Documents and resources Tactis has made available to you.</p>
      </div>
      <LibraryPanel />
    </div>
  );
}
